import { UseCase } from './UseCase';

export namespace GetValue {
    export type Params<T> = ParamsWithPath<T> | ParamsWithPaths<T>;

    export interface ParamsWithPath<T> {
        from: T;
        path: string;
    }

    export interface ParamsWithPaths<T> {
        from: T;
        paths: string[];
    }
}

export class GetValue implements UseCase<GetValue.Params<any>, any | undefined> {
    execute<T>(params: GetValue.Params<T>): any | undefined {
        let prop: any;
        if (this.hasPath(params)) {
            prop = params.from;
            const parts = params.path.split('.');
            parts.forEach((part) => {
                if (!this.isDefined(prop)) {
                    return;
                }

                prop = prop[part];
            });
        }

        if (!this.isDefined(prop) && this.hasPaths(params)) {
            params.paths.some((path) => {
                prop = this.execute({ path, from: params.from });
                return this.isDefined(prop);
            });
        }

        return prop;
    }

    protected hasPath<T>(params: GetValue.Params<T>): params is GetValue.ParamsWithPath<T> {
        const paramsWithPaths = <GetValue.ParamsWithPath<T>>params;
        return paramsWithPaths && !!paramsWithPaths.path;
    }

    protected hasPaths<T>(params: GetValue.Params<T>): params is GetValue.ParamsWithPaths<T> {
        const paramsWithPaths = <GetValue.ParamsWithPaths<T>>params;
        return paramsWithPaths && Array.isArray(paramsWithPaths.paths);
    }

    protected isDefined(value: any): boolean {
        return typeof value !== 'undefined' && value !== null;
    }
}
